import styled from 'styled-components';

const BusinessCellStyles = (Component) => styled(Component)`
  display: inline-flex;
`;

export default BusinessCellStyles;
